import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CountryFlag from '@components/CountryFlag';

import { removeItemFromGlobalFilter, updateTextItemInGlobalFilter } from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { getCRMCountryWiseSummary, getCRMYearWiseSummary } from '@services/crmService';

import { getNumberUnit, isCRMManagement } from '@utils/Util';

const CountryWiseBreakDown = () => {
	const filterData = useSelector((store) => store.filterFieldStore);
	const [summary, setSummary] = useState([]);
	const [globalSummary, setGlobalSummary] = useState({});
	const dispatch = useDispatch();

	const generateParams = () => {
		let params = ``;
		if (filterData?.year) {
			params += `?year=${filterData['year'][0]?.value}`;
		}
		return params;
	};

	const setDefaultFilterForTargetTab = async (obj, identifier) => {
		if (obj?.id) {
			let data = {
				name: identifier,
				type: 'text',
				key: obj.value,
				value: obj.id,
				identifier: identifier,
				isHideChip: true,
				isClearable: false
			};
			await dispatch(updateTextItemInGlobalFilter(data));
		}
	};

	useEffect(() => {
		(async () => {
			try {
				if (filterData?.year) {
					dispatch(openLoader());
					const params = generateParams();
					let data = [];
					if (isCRMManagement()) {
						data = await getCRMCountryWiseSummary(params);
					} else {
						data = await getCRMYearWiseSummary();
					}
					let totalTarget = 0;
					let totalAchieved = 0;
					data.map((item) => {
						totalAchieved += item?.achievedAmount || 0;
						totalTarget += item?.targetAmount || 0;
					});
					setGlobalSummary({ totalTarget, totalAchieved });
					setSummary(data);
					dispatch(closeLoader());
				} else {
					const data = await getCRMYearWiseSummary();
					let currentYear = new Date().getFullYear();
					let selectedYear = data.find((item) => item.year === currentYear);
					let defaultSelected = selectedYear
						? { id: selectedYear.year, value: selectedYear.year }
						: { id: data[0].year, value: data[0].year };
					await setDefaultFilterForTargetTab(defaultSelected, 'year');
				}
			} catch {
				dispatch(closeLoader());
			}
		})();
	}, [filterData]);

	const renderCountryBreakDown = () => {
		const isActive = (item) => {
			if (!isCRMManagement() && filterData['year'][0]?.value === item.year) {
				return 'active';
			} else if (
				isCRMManagement() &&
				filterData?.['countryId']?.[0]?.key === item.countryResponse?.id
			) {
				return 'active';
			} else {
				return '';
			}
		};

		const toggleFilter = (identifier, obj) => {
			let data = {
				name: identifier,
				type: 'text',
				key: obj.id,
				value: obj.value,
				identifier: identifier,
				isHideChip: true
			};
			dispatch(updateTextItemInGlobalFilter(data));
		};

		return summary?.map((item, idx) => {
			return (
				<div
					className={`single-country-details ${isActive(item)}`}
					key={`country_${idx}`}
					onClick={() => {
						if (isCRMManagement()) {
							toggleFilter('countryId', {
								id: item.countryResponse?.id,
								value: item.countryResponse?.name
							});
						} else {
							toggleFilter('year', {
								id: item.year,
								value: item.year
							});
						}
					}}
				>
					{isCRMManagement() && (
						<p className="regular-14 gray_dark_02 weight-500 mb-2">
							<CountryFlag countryId={item.countryResponse?.id} />
							&nbsp;
							{item.countryResponse?.name}
						</p>
					)}
					{!isCRMManagement() && (
						<p className="regular-14 gray_dark_02 weight-500 mb-2">{item.year}</p>
					)}
					<div className="value-info">
						<p className="regular-12 gray_dark_02">
							<span>Target:</span>{' '}
							<span className="semibold-16 gray_dark_02">
								{getNumberUnit(item.targetAmount, true)}
							</span>
						</p>
						<p className="regular-12 gray_dark_02">
							<span>Achieved:</span>{' '}
							<span className="semibold-16">{getNumberUnit(item.achievedAmount, true)}</span>
						</p>
					</div>
				</div>
			);
		});
	};

	return (
		<div className="country-wise-breakdown on-target-page scroll-x-label">
			{isCRMManagement() && (
				<div
					className={`single-country-details ${
						!filterData?.['countryId']?.[0]?.value ? 'active' : ''
					}`}
					onClick={() => {
						dispatch(removeItemFromGlobalFilter({ name: 'countryId', identifier: 'countryId' }));
					}}
				>
					<p className="regular-14 gray_dark_02 weight-500 mb-2">
						<img
							src={`${process.env.PUBLIC_URL}/icons/world.svg`}
							alt="global"
							className="mr-1"
						/>{' '}
						Global
					</p>
					<div className="value-info">
						<p className="regular-12 gray_dark_02">
							<span>Target:</span>{' '}
							<span className="semibold-16 gray_dark_02">
								{getNumberUnit(globalSummary.totalTarget, true)}
							</span>
						</p>
						<p className="regular-12 gray_dark_02">
							<span>Achieved:</span>{' '}
							<span className="semibold-16">
								{getNumberUnit(globalSummary.totalAchieved, true)}
							</span>
						</p>
					</div>
				</div>
			)}
			{renderCountryBreakDown()}
		</div>
	);
};

export default CountryWiseBreakDown;
